import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"/><path d="M18.35,19.89h-.89V15.26A1.15,1.15,0,0,0,16.21,14H13.84a1.23,1.23,0,1,0,0,2.45h1.07v3.41H13.65a1.23,1.23,0,1,0,0,2.45h4.7a1.23,1.23,0,1,0,0-2.45Z"/><path d="M15.91,12.71a1.53,1.53,0,0,0,0-3.05,1.53,1.53,0,1,0,0,3.05Z"/>';
export var InfoOutlineSVG = function InfoOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
InfoOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(InfoOutlineSVG);